import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useComponentProperties, useFetchedValues } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from 'react';
import { byAttributeName } from "../../utils";

const WorkProperty = () => {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();

    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [workAttributes, setWorkAttributes] = useState([]);

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const workAttributes = fetchedValues.attributes
                .filter(attribute => !attribute.isSystemAttribute && attribute.attributeType === "Number")
                .sort(byAttributeName);
            setWorkAttributes(workAttributes)
        }
    }, [fetchedValues.attributes])

    const handleWorkPropertyChange = (e) => {
        const workAttribute = e.target.value && e.target.value._id ? e.target.value : { _id: "" };
        setProperty("workAttribute", workAttribute);
    }

    return (
        <div className="clearBtn">
            <ComboBox
                className="w-100 select-overflow "
                disabled={selectedComponent.hidden}
                onChange={handleWorkPropertyChange}
                value={properties.workAttribute}
                textField='attributeName'
                data={workAttributes}
                dataItemKey='_id'
            />
        </div>
    )
}

export default WorkProperty;